<template>
  <div>
    <concise-card-have-title-acquiescent
      :showTitle="true"
      title="基础管理--角色管理--权限分配"
      titleWidth="300px"
      icon="icon-setting-role"
      :tableHeaderOperationList="operationForButtonOfTableHeader"
      @operationForButton="operationForButton"
    >
      <div slot="body">
        <div class="clearfix">
          <el-tree
            :data="allAuthorityList"
            show-checkbox
            default-expand-all
            :check-strictly="false"
            :render-content="renderContent"
            node-key="code"
            :props="defaultProps"
            ref="tree"
            @check-change="handleCheckChange"
            :default-checked-keys="defaultCheckedList"
            :expand-on-click-node="false"
            :check-on-click-node="true"
          ></el-tree>
          <div class="footer_Button fr">
            <el-button type="warning" @click="$router.back()">取消</el-button>
            <el-button type="primary" @click="saveRoleCompetence">保存</el-button>
          </div>
        </div>
      </div>
    </concise-card-have-title-acquiescent>
  </div>
</template>

<script>
export default {
  components: {
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
  },
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultCheckedList: [],
      flag: false, // 控制加不加样式的标识，如果没有这样一步，样式是没有效果的
      parentList: [], // 权限管理父节点
      childList: [], // 权限管理的子节点
      allAuthorityList: [],
      operationForButtonOfTableHeader: [
        {
          title: "<span class='el-icon-caret-left m_r5'></span>返回",
          key: 'back',
          type: 'primary',
          size: ''
        }
      ]
    }
  },
  watch: {
    flag: function (newval) {
      if (newval) {
        // 用于加样式，让tree控件横向展示
        this.changeCss()
      }
    }
  },
  methods: {
    // 内容区渲染后执行判断底层赋class
    renderContent (h, { node, data, store }) {
      let classname = ''
      if (node.level === 1) {
        classname = 'treeParent'
      } else if (node.level === 2) {
        classname = 'levelname'
      }
      // 由于项目中有二级菜单也有三级菜单，就要在此做出判断。
      if (node.level === 2 && node.childNodes.length === 0) {
        classname = 'levelname'
      }
      this.flag = true
      return <p class={classname}>{node.label}</p>
    },

    // 根据上面的加的不一样的类名来设置相应的样式：
    changeCss () {
      var levelName = document.getElementsByClassName('levelname') // levelname是上面的最底层节点的名字
      for (var i = 0; i < levelName.length; i++) {
        // cssFloat 兼容 ie6-8  styleFloat 兼容ie9及标准浏览器
        levelName[i].parentNode.style.cssFloat = 'left' // 最底层的节点，包括多选框和名字都让他左浮动
        levelName[i].parentNode.style.styleFloat = 'left'
        levelName[i].parentNode.style.float = 'left'
        levelName[i].parentNode.style.backgroundColor = '#FFF'
      }
      var treeParent = document.getElementsByClassName('treeParent')
      for (var j = 0; j < treeParent.length; j++) {
        treeParent[j].parentNode.style.marginTop = '20px'
        treeParent[j].parentNode.style.marginBottom = '5px'
        if (j === 0) {
          treeParent[j].parentNode.style.marginTop = '0px'
        }
      }
    },

    // 获取选中和半选中状态下的数据
    handleCheckChange () {
      // 这是可以获取到某个节点全选或者选中部分：包括全选的父节点和子节点，半选的子节点：
      //  return this.$refs.tree.getCheckedKeys();
      //  这是可以获取到半选的状态，只可以获取到半选的父节点，不能获取到全选的父节点，更不能获取到子节点：
      //  return this.$refs.tree.getHalfCheckedKeys();
      // 把上面的两种获取拼接起来：
      // return `${this.$refs.tree.getHalfCheckedKeys()} + ${this.$refs.tree.getCheckedKeys()}`;
      var allList = this.$refs.tree.getCheckedKeys(false) // 获取到所有勾选的
      var childrenList = this.$refs.tree.getCheckedKeys(true) // 获取到子集的
      var concatList = [...allList, ...childrenList]
      var newList = concatList.filter((item, i, arr) => {
        // 筛选出父级
        return arr.indexOf(item) === arr.lastIndexOf(item)
      })
      this.childList = childrenList
      // getHalfCheckedKeys, 则返回目前半选中的节点的 key 所组成的数组:
      this.parentList = newList.concat(this.$refs.tree.getHalfCheckedKeys()) // 父级：半选的加上全选的
    },

    async getAllAuthority () {
      try {
        let _that = this
        let { data: result } = await _that.$http.getAllAuthority()
        if (result.code !== 200) return this.$message.error(result.msg)
        this.allAuthorityList = JSON.parse(
          JSON.stringify(result.data).replace(/descr/g, 'name')
        )
      } catch (err) {
        console.log(err)
      }
    },

    async saveRoleCompetence () {
      try {
        let newArr = this.childList.map(item => {
          return {
            authCode: item,
            roleId: Number(this.$route.query.id)
          }
        })
        const { data: result } = await this.$http.saveRoleAuthoritysOfRole(newArr)
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('权限编辑成功，将在下一次登录的时候生效')
        setTimeout(() => {
          this.$router.back()
        }, 500)
      } catch (err) {
        console.log(err)
      }
    },

    async getRoleInfo () {
      try {
        let _that = this
        let params = {
          roleId: this.$route.query.id
        }
        let { data: result } = await _that.$http.getRoleAuthoritys(params)
        if (result.code !== 200) return this.$message.error(result.msg)
        this.defaultCheckedList = this.childList = result.data.map(
          item => item.code
        )
      } catch (err) {
        console.log(err)
      }
    },

    // 操作按钮：
    operationForButton ({ key }) {
      switch (key) {
        case 'back':
          this.$router.go(-1)
          break
      }
    }
  },

  created () {
    if (!this.$route.query.id) this.$router.back()
    this.getRoleInfo()
    this.getAllAuthority()
  }
}
</script>

<style lang="scss" scoped>
$themeBgc: #fff;
// $themeCheck: #d8372b;
$themeCheck: #EE7F2E;
// 样式更改，内容框框：
.cardContent_Box {
  background-color: $themeBgc;
  color: #000;
  border: none;
  border-radius: 0px;
  /deep/.el-card__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

// 组织架构的背景色：整体的背景色：+++++++++++++++++++++++++++++++++++++
/deep/.el-tree {
  background-color: $themeBgc;
  padding-top: 10px;
  padding-bottom: 20px;
}
/deep/.el-tree-node {
  background-color: $themeBgc;
  color: #000;
}
// 树形图的高亮：鼠标经过以及获得焦点的时候的背景色：+++++++++++++++++++++
/deep/.el-tree-node__content:hover {
  background-color: $themeBgc;
}
/deep/.el-tree-node:focus > .el-tree-node__content {
  background-color: $themeBgc;
}
// 选中的时候的颜色：++++++++++++++++++++++++++++++
/deep/ .el-tree-node.is-checked > .el-tree-node__content {
  background-color: $themeBgc;
}
/deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: $themeBgc;
}
// 复选框的样式：
.el-checkbox {
  color: #000;
}

// 原始，选中之后框框为此色：
/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: $themeCheck;
  border-color: $themeCheck;
}
/deep/.el-checkbox.is-checked + .el-tree-node__label {
  color: $themeCheck;
}

// 自己进行了改造，选中之后为此色：
/deep/.el-checkbox__input.is-checked .levelname {
  background-color: $themeCheck;
  border-color: $themeCheck;
}
/deep/.el-checkbox.is-checked + .levelname {
  color: $themeCheck;
}
/deep/.el-checkbox.is-checked + .treeParent {
  color: $themeCheck;
}

// 选择框离右边文字的距离：
/deep/.el-tree-node__label {
  margin-left: 10px;
}
// 当没有数据的时候：背景色：
/deep/.el-tree__empty-block {
  background-color: $themeBgc;
}
.footer_Button {
  margin-top: 15px;
}

// 半选状态下面的一级度选框的样式：
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: $themeCheck;
  border-color: $themeCheck;
}
/deep/.el-checkbox__inner {
  margin-right: 10px;
}
</style>
